<template>
  <div class="malay-expenditure">
    <div class="page-section" style="border-top: none;">
      <el-form class="page-search__form" ref="searchForm" :model="listInfo">
        <div class="page-search__item page-search__item_large">
          <el-form-item>
            <el-date-picker
              v-model="listInfo.date"
              unlink-panels
              clearable
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :range-separator="$t('common.dateRangeTo')"
              :start-placeholder="$t('common.dateStart')"
              :end-placeholder="$t('common.dateEnd')"
              @change="handleDateChange"
            ></el-date-picker>
          </el-form-item>
        </div>
        <div class="page-search__item">
          <el-form-item>
            <el-input :placeholder="$t('common.passportNo')" clearable v-model="listInfo.passportNum"></el-input>
          </el-form-item>
        </div>
        <div class="page-search__item">
          <el-form-item>
            <el-input :placeholder="$t('common.name')" clearable v-model="listInfo.name"></el-input>
          </el-form-item>
        </div>
        <div class="page-search__item">
          <el-form-item>
            <el-select :placeholder="$t('common.status')" clearable filterable v-model="listInfo.visaFeeStatus">
              <el-option :label="$t('common.all')" value="null"></el-option>
              <el-option :label="$t('common.paySuccess')" value="CHECK_SUCCESS"></el-option>
              <el-option :label="$t('common.payFailed')" value="CHECK_FAILED"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="page-search__btns">
          <div class="page-search__btns-left">
            <el-button
              type="primary"
              class="page-button_medium page-button_blue"
              :loading="downloadLoading"
              @click="download"
            >{{ $t('common.exportReport') }}</el-button>
          </div>
          <div class="page-search__btns-right">
            <el-button
              type="primary"
              class="page-button_medium"
              @click="getMalayExpenditureDate()"
            >{{ $t('common.search') }}</el-button>
            <el-button @click="resetSearch">{{ $t('common.cancel') }}</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <div class="page-section">
      <div class="page-table" v-if="tableHeight > 0">
        <el-table
          :data="listData"
          :max-height="tableHeight + 'px'"
          v-loading="listLoading"
          :element-loading-text="$t('common.loading')"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column fixed prop="payTime" :label="$t('financial.usa.payTime')" min-width="180px"></el-table-column>
          <el-table-column
            prop="userName"
            :label="$t('financial.usa.customerName')"
            :formatter="formatToEmpty"
            min-width="180px"
          ></el-table-column>
          <el-table-column
            prop="passportNum"
            :label="$t('common.passportNo')"
            :formatter="formatToEmpty"
            min-width="160px"
          ></el-table-column>
          <el-table-column prop="feeStatus" :label="$t('common.status')" min-width="160px">
            <template slot-scope="{ row }">
              <span
                :class="{
                'fee_success': row.feeStatus == 'CHECK_SUCCESS',
                'fee_failed': row.feeStatus == 'CHECK_FAILED'
              }"
              >{{ formatFeeStatus(row.feeStatus) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="payVisaFee"
            :formatter="formatToYuan"
            :label="$t('financial.usa.spendAmount')"
            min-width="160px"
          ></el-table-column>
          <el-table-column :label="$t('common.operatorStaff')" prop="nick" min-width="180px"></el-table-column>
        </el-table>
      </div>
      <div class="page-pagination">
        <el-pagination
          layout="total, prev, pager, next, jumper"
          @current-change="getMalayExpenditureDate"
          :current-page="listInfo.pageNum"
          :page-size="listInfo.pageSize"
          :total="listInfo.totalCount"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import * as financialApi from '@/apis/financial'
import { formatToYuan, formatToEmpty } from '@/utils/formatters'
import { getBaseURL } from '@/utils/util'
import { defaultSearchDate } from '@/data/constant'

export default {
  name: 'malayExpenditure',
  props: {
    tableHeight: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      formatToYuan,
      formatToEmpty,
      listInfo: {
        name: '',
        passportNum: '',
        date: defaultSearchDate,
        dateFrom: defaultSearchDate[0],
        dateTo: defaultSearchDate[1],
        visaFeeStatus: '',
        payStatus: 0,
        pageNum: 1,
        pageSize: 20,
        totalCount: 0,
      },
      listData: [],
      listLoading: false,
      downloadLoading: false,
    }
  },
  activated() {
    this.getMalayExpenditureDate()
  },
  methods: {
    formatFeeStatus(value) {
      if (value == 'CHECK_SUCCESS') return this.$t('common.paySuccess')
      if (value == 'CHECK_FAILED') return this.$t('common.payFailed')
      return '--'
    },
    async getMalayExpenditureDate(pageNum = 1) {
      this.listLoading = true
      try {
        this.listInfo.pageNum = pageNum

        const result = await financialApi.getMalayExpenditureDate(this.listInfo)
        this.listLoading = false

        if (result) {
          const { records, pageNum, totalCount } = result.pageInfo
          this.listData = records || []
          this.listInfo = {
            ...this.listInfo,
            pageNum,
            totalCount,
          }
        }
      } catch (err) {
        this.listLoading = false
        throw new Error(err)
      }
    },
    resetSearch() {
      this.listInfo = {
        name: '',
        passportNum: '',
        date: defaultSearchDate,
        dateFrom: defaultSearchDate[0],
        dateTo: defaultSearchDate[1],
        visaFeeStatus: '',
        payStatus: 0,
        pageNum: 1,
        pageSize: 20,
        totalCount: 0,
      }
      this.$refs.searchForm.clearValidate()
      this.getMalayExpenditureDate()
    },
    handleDateChange(value) {
      if (value && value[0] && value[1]) {
        this.listInfo.dateFrom = value[0]
        this.listInfo.dateTo = value[1]
      } else {
        this.listInfo.dateFrom = ''
        this.listInfo.dateTo = ''
      }
    },
    async download() {
      this.downloadLoading = true
      try {
        const result = await financialApi.downloadMalayExpenditureData(
          this.listInfo
        )
        this.downloadLoading = false
        if (result) {
          window.open(getBaseURL('api', true) + result.pageInfo.downloadUrl)
        }
      } catch (err) {
        this.downloadLoading = false
        throw new Error(err)
      }
    },
  },
}
</script>
